import React from 'react'
import PropTypes from 'prop-types'
import { UnitCreators } from '@leverege/api-attributes'

import BooleanViewer from './BooleanViewer'
import IntViewer from './IntViewer'
import NumberViewer from './NumberViewer'
import UnitViewer from './UnitViewer'
import PercentViewer from './PercentViewer'
import StringViewer from './StringViewer'
import TimestampViewer from './TimestampViewer'
import RelationhipViewer from './RelationshipViewer'
import ShapeViewer from './ShapeViewer'
import GeoJsonViewer from './GeoJsonViewer'
import GeoPointViewer from './GeoPointViewer'
import EnumViewer from './EnumViewer'
import ResourceEnumViewer from './ResourceEnumViewer'
import ParentRelationshipViewer from './ParentRelationshipViewer'

function createViewer( attribute, device, prps ) {
  if ( attribute == null ) {
    return null;
  }
  
  const props = {
    ...prps,
    attribute,
    device
  }

  switch ( attribute.type ) {
    case BooleanViewer.TYPE: return <BooleanViewer {...props} />
    case IntViewer.TYPE: return <IntViewer {...props} />
    case NumberViewer.TYPE: return <NumberViewer {...props} />
    case PercentViewer.TYPE: return <PercentViewer {...props} />
    case StringViewer.TYPE: return <StringViewer {...props} />
    case TimestampViewer.TYPE: return <TimestampViewer {...props} />
    case RelationhipViewer.TYPE: return <RelationhipViewer {...props} />
    case ShapeViewer.TYPE: return <ShapeViewer {...props} />
    case GeoJsonViewer.TYPE: return <GeoJsonViewer {...props} />
    case GeoPointViewer.TYPE: return <GeoPointViewer {...props} />
    case EnumViewer.TYPE: return <EnumViewer {...props} />
    case ResourceEnumViewer.TYPE: return <ResourceEnumViewer {...props} />
    case ParentRelationshipViewer.TYPE: return <ParentRelationshipViewer {...props} />

    // Handle any explicity units here.
    default: {
      const uTypes = UnitCreators.getCreators();
      for ( let n = 0; n < uTypes.length; n++ ) {
        if ( uTypes[n].typeName() === attribute.type ) {
          return <UnitViewer {...props} />
        }
      }
    }
  }
  return <div /> 
}

export default {
  createViewer
}
